export function dataInRequest(params = {}) {
  return {
    type: '@pitStopJustificativa/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@pitStopJustificativa/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@pitStopJustificativa/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@pitStopJustificativa/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@pitStopJustificativa/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@pitStopJustificativa/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@pitStopJustificativa/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@pitStopJustificativa/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@pitStopJustificativa/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@pitStopJustificativa/RECORD_FILTERING',
    payload: { params },
  };
}
